export var FlavorType;
(function (FlavorType) {
    FlavorType["chrome"] = "E";
    FlavorType["edge"] = "CM";
    FlavorType["firefox"] = "F";
})(FlavorType || (FlavorType = {}));
